"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYNC_BRANDING_SETTINGS = exports.GET_BRANDING_SETTINGS = void 0;
var GET_BRANDING_SETTINGS = exports.GET_BRANDING_SETTINGS = 'GET_BRANDING_SETTINGS';
var SYNC_BRANDING_SETTINGS = exports.SYNC_BRANDING_SETTINGS = 'SYNC_BRANDING_SETTINGS';